import React from "react";
let index = 0

export default function PanelCard({ title, description, icon,date }) {


    const createRipple = (event) => {
        if (event.type === "keydown" && event.keyCode !== 32) return;

        const button = event.currentTarget 
        const btnRect = button.getBoundingClientRect();

        const circle = document.createElement("span");
        const diameter = Math.max(btnRect.width, btnRect.height);
        const radius = diameter / 2;

        circle.style.width = circle.style.height = `${diameter}px`;
        circle.style.left = `${event.clientX - btnRect.left - radius}px`;
        circle.style.top = `${event.clientY - btnRect.top - radius}px`;
        circle.classList.add("ripple");

        const ripple = button.getElementsByClassName("ripple")[0];

        if (ripple) ripple.remove();

        button.appendChild(circle);

    };

    return (
        <div
            data-lazy='fade-up'
            className="card panel-card"
            onMouseDown={(e) => {
                createRipple(e);
            }}
            onKeyDown={(e) => {
                createRipple(e);
            }}
        >
            <data className="card-icon">{icon}</data>
            <div className="wrapper">
                <data className="card-date">{date}</data>
                <h4 className="card-title">{title}</h4>
                <p className="card-description">{description}</p>
            </div>
        </div>
    );
}
